/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable default-case */
import React, { useState, useEffect} from 'react'
import NavigationBar from '../components/NavBar'
import { message } from '../components/SocketIO'

var selectedDriver = null
var currentDate = new Date()
var driverListArray = []

var permanentSelectedDate = null

const AutoSchedule = (props) => {
    // eslint-disable-next-line no-extend-native
    Date.prototype.getWeek = function () {
       var firstDate = new Date(this.getFullYear(), 0, 1)
       return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7)
    }
    var CryptoJS = require("crypto-js");
    const [ drivers, setDrivers ] = useState(null)
    const [ schedule, setSchedule ] = useState([])
    const [ socketGate, setSocketGate ] = useState([])
    const [ driverNameList, setDriverNameList ] = useState([])
    const [ stationDrivers, setStationDrivers ] = useState([])
    const [ stateSelectedDriver, setStateSelectedDriver ] = useState(null)
    const [ selectedDriverList, setSelectedDriverList ] = useState([])
    const [ selectedDriverArrayDisplay, setSelectedDriverArrayDisplay ] = useState([])
    const [ buttonArrayList, setButtonArrayList ] = useState([])
    const [ monday, setMonday ] = useState(false)
    const [ tuesday, setTuesday ] = useState(false)
    const [ wednesday, setWednesday ] = useState(false)
    const [ thursday, setThursday ] = useState(false)
    const [ friday, setFriday ] = useState(false)
    const [ saturday, setSaturday ] = useState(false)
    const [ sundayButton, setSundayButton ] = useState(false)
    const [ optionsThree, setOptionsThree ] = useState([])
    const [ sunday, setSunday ] = useState(new Date())
    const [ buttonsArray, setButtonsArray ] = useState([])
    const [ dateArray, setDateArray ] = useState([])
    const [ reReload, setReReload ] = useState(0)
    const [ waiting, setWaiting ] = useState(false)
    const [ submittedScreen, setSubmittedScreen ] = useState(null)
    const [ americanDateArray, setAmericanDateArray ] = useState([])
    const [ sentGate, setSendGate ] = useState(false)

    useEffect( () =>{
        let myDate = new Date()
        while (myDate.getDay() > 0) {
            myDate.setDate(myDate.getDate() - 1)
        }
        let aDate = new Date(myDate)
        setSunday(aDate)
    }, [])

    useEffect(() => {
        // set sunday initially

        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'POST', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')
        };
        postData('https://backendpajamas.herokuapp.com/autoschedule/', {
            date: sunday.toDateString(),
            week: sunday.getWeek()
        }).then( (response) => {
            response.data.drivers[props.selectedCity].sort( (a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 :-1 ))
            setDrivers([])
            let driverArray = []
            response.data.drivers[props.selectedCity].forEach( driver => {
                if (driver.status !== 'OffboardedForever') {
                    driverArray.push(driver)
                }
            })
            setDrivers(driverArray)
            socketGate ? setSocketGate(false) : setSocketGate(true)
        })
    }, [sentGate, sunday])

    // make an array of this weeks dates
    useEffect( () => {
        let thisDate = new Date(sunday)
        let first = thisDate.toDateString()
        let second = new Date(thisDate.setDate(thisDate.getDate() + 1)).toDateString()
        let third = new Date(thisDate.setDate(thisDate.getDate() + 1)).toDateString()
        let fourth = new Date(thisDate.setDate(thisDate.getDate() + 1)).toDateString()
        let fifth = new Date(thisDate.setDate(thisDate.getDate() + 1)).toDateString()
        let sixth = new Date(thisDate.setDate(thisDate.getDate() + 1)).toDateString()
        let seventh = new Date(thisDate.setDate(thisDate.getDate() + 1)).toDateString()
        setAmericanDateArray([
            first, second, third, fourth, fifth, sixth, seventh
        ])
    }, [sunday])

    useEffect( () => {
        // connec to the socket
        message((err, message) => {
            async function postData(url = '', data = {}) {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'POST', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    },
                    body: JSON.stringify(data)
                    });
    
                return response ? response.json() : console.log('no reponse')
            };
            let theDateWeek = new Date(permanentSelectedDate).getWeek()
            postData('https://backendpajamas.herokuapp.com/autoschedule/', {
                date: permanentSelectedDate,
                week: theDateWeek
            }).then( response => {
                response.data.drivers[props.selectedCity].sort( (a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 :-1 ))
                let driverArray = []
                response.data.drivers[props.selectedCity].forEach( driver => {
                    if (driver.status !== 'OffboardedForever') {
                        driverArray.push(driver)
                    }
                })
                setDrivers(driverArray)
            })
        }, 'I have joined the chat', props.user_name)
    }, [socketGate])

    useEffect( () => {
        permanentSelectedDate = props.selectedDate
    }, [props.selectedDate])

    useEffect( () => {
        let thisDate = new Date(sunday)
        let first = thisDate.toLocaleDateString('en-GB')
        let second = new Date(thisDate.setDate(thisDate.getDate() + 1)).toLocaleDateString('en-GB')
        let third = new Date(thisDate.setDate(thisDate.getDate() + 1)).toLocaleDateString('en-GB')
        let fourth = new Date(thisDate.setDate(thisDate.getDate() + 1)).toLocaleDateString('en-GB')
        let fifth = new Date(thisDate.setDate(thisDate.getDate() + 1)).toLocaleDateString('en-GB')
        let sixth = new Date(thisDate.setDate(thisDate.getDate() + 1)).toLocaleDateString('en-GB')
        let seventh = new Date(thisDate.setDate(thisDate.getDate() + 1)).toLocaleDateString('en-GB')
        setDateArray([
            first, second, third, fourth, fifth, sixth, seventh
        ])
    }, [sunday])

    // update the outside react array
    useEffect( () => {
        driverListArray = selectedDriverList 
    }, [selectedDriverList])

    // update the outside react one
    useEffect( () => {
        selectedDriver = stateSelectedDriver
    }, [stateSelectedDriver])

    // select the driver for editing
    const handleSelectDriver = (e, driver) => {
        // make current selection
        setStateSelectedDriver(driver)
        // make the array of selected
        if (driverListArray.length > 0) {
            let localArray = [...driverListArray]
            let nameList = []
            localArray.forEach( ele => {
                nameList.push(ele.name)
            })
            if (!nameList.includes(driver.name)) {
                localArray.push(driver)
            }
            setSelectedDriverList(localArray)
        } else {
            let localArray = []
            localArray.push(driver)
            setSelectedDriverList(localArray)
        }
    }

    // make the list of names for selection
    useEffect( () => {
        if (drivers) {
            let driverNamesList = []
            setStationDrivers(drivers)
            // console.log(driverList)
            drivers.forEach( (driver, driverId) => {
                driverNamesList.push(
                    <h3 className='hoverClick' onClick={(e, item) => handleSelectDriver(e, driver)}>{driverId+1}. {driver.name}</h3>
                )
            })
            driverNamesList.sort((a, b) => (String(a).toLowerCase() > String(b).toLowerCase() ? -1 : 1))
            setDriverNameList(driverNamesList)
        }
    }, [drivers])

    // function for taking names away from array
    const handleSelectDriverArray = (e, driver) => {
        let arrayToReturn = []
        let localArray = [...driverListArray]
        localArray.forEach( driverY => {
            if (driverY.driver_id !== driver.driver_id) {
                arrayToReturn.push(driverY)
            }
        })
        setSelectedDriverList(arrayToReturn)
    }

    // handle toggling the days
    const handleDayClick = (e, dayName) => {
        switch(dayName) {
            case 'Monday':
                monday === false ? setMonday(true) : setMonday(false)
                break;
            case 'Tuesday':
                tuesday === false ? setTuesday(true) : setTuesday(false)
                break;
            case 'Wednesday':
                wednesday === false ? setWednesday(true) : setWednesday(false)
                break;
            case 'Thursday':
                thursday === false ? setThursday(true) : setThursday(false)
                break;
            case 'Friday':
                friday === false ? setFriday(true) : setFriday(false)
                break;
            case 'Saturday':
                saturday === false ? setSaturday(true) : setSaturday(false)
                break;
            case 'Sunday':
                sundayButton === false ? setSundayButton(true) : setSundayButton(false)
                break;
        }
    }

    // make the array of drivers selected
    useEffect( () => {
        let selectedDriverArray = []
        selectedDriverList.forEach( (selectedDriver) => {
            selectedDriverArray.push(
                <h3 className='hoverClick' onClick={(e, item) => handleSelectDriverArray(e, selectedDriver)}>{selectedDriver.name}</h3>
            )
        })
        setSelectedDriverArrayDisplay(selectedDriverArray)
    }, [selectedDriverList])

    // make the button selections
    useEffect( () => {
        const makeButtons = (sunday, monday, tuesday, wednesday, thursday, friday, saturday) => {
            let buttonArray = []
            let arrayOfBools = [sunday, monday, tuesday, wednesday, thursday, friday, saturday]
            let arrayOfNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
            arrayOfBools.forEach( (day, dayId) => {
                if (day) {
                    buttonArray.push(
                        <div className='auto_schedule_add_driver_button_submit_van_owner_true_non' onClick={(e, item) =>handleDayClick(e, arrayOfNames[dayId])}>
                            <span className='span_in_complaince_button_van_owner_false_non'>
                                {arrayOfNames[dayId]}<br />
                                {dateArray[dayId]}
                            </span>
                        </div>
                    )
                } else {
                    buttonArray.push(
                        <div className='auto_schedule_add_driver_button_submit_van_owner_false_non' onClick={(e, item) =>handleDayClick(e, arrayOfNames[dayId])}>
                            <span className='span_in_complaince_button_van_owner_true_non'>
                                {arrayOfNames[dayId]}<br />
                                {dateArray[dayId]}
                            </span>
                        </div>
                    )
                }
            })
            return buttonArray
        }
        setButtonsArray(makeButtons(sundayButton, monday, tuesday, wednesday, thursday, friday, saturday))

    }, [monday, tuesday, wednesday, thursday, friday, saturday, sundayButton, dateArray])

    // 
    const handleSelectSunday = (e, dateOne, dateTwo) => {
        // change the fields in the backend
        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'POST', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')
        };

        postData('https://backendpajamas.herokuapp.com/autoschedule/', {
            date: dateOne,
            week: new Date(dateOne).getWeek()
        }).then( response => {
            response.data.drivers[props.selectedCity].sort( (a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 :-1 ))
            let driverArray = []
            response.data.drivers[props.selectedCity].forEach( driver => {
                if (driver.status !== 'OffboardedForever') {
                    driverArray.push(driver)
                }
            })
            setDrivers(driverArray)
        })
        setSunday(new Date(dateOne))
    }

    // get sundays
    const getSundaysTwo = () => {
        let sundays = []
        let currentDate = new Date()
        for (let i = 7; i < 42; i++) {
            let dateInner = new Date(currentDate.getFullYear(), currentDate.getMonth(), i)
            if (dateInner.getDay() === 0) {
                sundays.push(
                    <li className="menu-item" onClick={(e, city) => handleSelectSunday(e, `${dateInner.toDateString()}`, `${dateInner.toDateString()}`)}><a href="#0">{dateInner.toLocaleDateString('en-GB')} | Week: {dateInner.getWeek()}</a></li>
                    )
            }
        }
        return sundays
    }

    // make the list of sundays for the backend
    useEffect( () => {
        setOptionsThree(getSundaysTwo())
    }, [])

    // handle submitting dates to backend
    const handleSubmit = () => {
        setWaiting(true)
        let myDateTime = new Date()
        let hours = myDateTime.getHours()
        let minutes = myDateTime.getMinutes()

        let timeEntry = `${hours}:${minutes}`
        const getDatesToSend = (sunday, monday, tuesday, wednesday, thursday, friday, saturday) => {
            let x = 0
            let dateArrayInner = []
            sunday ? dateArrayInner.push(new Date(americanDateArray[0]).toDateString()) : x++
            monday ? dateArrayInner.push(new Date(americanDateArray[1]).toDateString()) : x++
            tuesday ? dateArrayInner.push(new Date(americanDateArray[2]).toDateString()) : x++
            wednesday ? dateArrayInner.push(new Date(americanDateArray[3]).toDateString()) : x++
            thursday ? dateArrayInner.push(new Date(americanDateArray[4]).toDateString()) : x++
            friday ? dateArrayInner.push(new Date(americanDateArray[5]).toDateString()) : x++
            saturday ? dateArrayInner.push(new Date(americanDateArray[6]).toDateString()) : x++
            return dateArrayInner
        }
        let sendDatesArray = getDatesToSend(sundayButton, monday, tuesday, wednesday, thursday, friday, saturday)
        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'POST', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')
        };
        async function loopThroughAndSubmit () {
            const isValidDate = (d) => {
                return d instanceof Date && !isNaN(d);
              }
            try {
                driverListArray.forEach( driver => {
                    let checkArray = []
                    driver.datesList.forEach( date => {
                        checkArray.push(date.date)
                    })
                    sendDatesArray.forEach( dateToSend => {
                        if (!checkArray.includes(dateToSend)) {
                            if (isValidDate(new Date(dateToSend))) {
                                postData('https://backendpajamas.herokuapp.com/schedule/', {
                                    date: dateToSend,
                                    logIn_time: timeEntry,
                                    logOut_time: timeEntry,
                                    location: driver.location,
                                    driver_id: `https://backendpajamas.herokuapp.com/drivers/${driver.driver_id}/`,
                                    week_number: new Date(dateToSend).getWeek()
                                })
                            }
                        }
                    })
                })
            } catch(error) {
                console.log(error)
            }
            driverListArray=[]
            socketGate ? setSocketGate(false) : setSocketGate(true)
            sentGate === false ? setSendGate(true) : setSendGate(false)
            return 'done'
        }
        loopThroughAndSubmit().then( response => {
            setWaiting(false)
            setSubmittedScreen(
                <div className='sibmittedScreenAfter'>
                    <h3>Dates Submitted</h3>
                </div>
            )
            setSelectedDriverList([])
            setMonday(false)
            setTuesday(false)
            setWednesday(false)
            setThursday(false)
            setFriday(false)
            setSaturday(false)
            setSundayButton(false)
            setTimeout( () => {
                setSubmittedScreen(null)
            }, 3000)
        })
    }

    var content
    if (waiting) {
        content = (
            <div className='home_content'>
                <NavigationBar title='Booking drivers' superUser={props.superUser ? true : false}/>
                <div className='bodyWater'>
                    <div class="water">
                        <h1 className='loadingTitle'>
                            H2O Logistics
                        </h1>
                    </div>
                </div>
            </div>
        )
    } else {
        content = (
            <div className='home_content'>
                <NavigationBar title='Auto Scheduling' superUser={props.superUser ? true : false}/>
                    <div className='autoScheduleDateList'>
                        <nav className="menu">
                            <ol>
                                <li className="menu-item"><a href="#0">{sunday.toLocaleDateString('en-GB')}</a>
                                    <ol className="sub-menu">
                                        {optionsThree}
                                    </ol>
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className='autoScheduleDateListTwo'>
                        <div className='submit_add_driver_button_submit_van_owner_false_nonTwo' onClick={() => props.returnMe()}>
                            <span className='span_in_complaince_button_van_owner_true_non'>Return</span>
                        </div>
                    </div>
                    {submittedScreen}
                <div className='autoSchedulingContentContainer'>
                    <div className='selectableDriverList'>
                        <h3 className='stickyLabel'>{props.selectedCity}</h3>
                        {driverNameList}
                    </div>
                    <div className='selectedDriverMain'>
                        <h2 className='stickyLabelTwo'>Submission Screen</h2>
                        <div className='innerAutoSchedule'>
                            <div className='selectedDriverList'>
                                <h3 className='stickyLabelInside'>Selected Drivers</h3>
                                {selectedDriverArrayDisplay}
                            </div>
                            <div className='selectedDaysContainer'>
                                <div className='buttonsContainer'>
                                    {buttonsArray}
                                </div>
                                <div className='submit_add_driver_button_submit_van_owner_false_non' onClick={handleSubmit}>
                                    <span className='span_in_complaince_button_van_owner_true_non'>Submit</span>
                                </div>
                            </div>
                        </div> 
                    </div>
                </div>
            </div>
        )
    }

    return (
        <>
        {content}
        </>
    )
}
export default AutoSchedule